import React, { memo, Suspense, useEffect, useState } from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import ModalContext from '../Context/ModalContext';
import { SalesCreditMiniForm } from '../../views/salesLedger/salesCredit/salesCreditCommon';
import { Maybe } from '../../graphql/schema/p4types';
import { InfoButton } from '../connectedForm/Button';
import { alternateFullScreenModalStyle } from './Styles';
import { IFormAction } from '../../@types/entityTypes';
import { SalesCreditActions } from '../../actions/salesLedger/SalesCreditActions';
import FluentModal from './FluentModal';

const LazySalesCreditForm = React.lazy(() => import('../../views/salesLedger/salesCredit/SalesCreditForm'));

const SalesCreditFormModal = memo(
  ({
    closeModal,
    activeTabId,
    modalState: { modalOpen: isOpen, uuid: newCreditUuid, initialValues, miniForm } = { modalOpen: false },
    readOnly = false,
    viaTradeCounter = false,
  }: {
    closeModal: (values?: any) => void;
    activeTabId?: string;
    modalState: { modalOpen: boolean; uuid?: Maybe<string>; initialValues?: any; miniForm?: SalesCreditMiniForm };
    readOnly?: boolean;
    viaTradeCounter?: boolean;
  }) => {
    const [openMiniForm, setOpenMiniForm] = useState<Maybe<SalesCreditMiniForm>>(miniForm);
    useEffect(() => {
      setOpenMiniForm(miniForm);
    }, [miniForm]);

    const miniFormAction: IFormAction<SalesCreditActions> | undefined = miniForm
      ? {
          text: openMiniForm ? 'Full Form' : 'Refund Form',
          onClick: () => setOpenMiniForm(!!openMiniForm ? null : miniForm),
          individualButton: true,
          individualButtonComponent: InfoButton,
          ignorePermissions: true,
          actionReference: SalesCreditActions.MiniForm,
        }
      : undefined;

    return (
      <ModalContext.Provider
        value={{
          onClose: closeModal,
          tabStyles: { container: { height: '600px' } },
          style: alternateFullScreenModalStyle,
        }}
      >
        <FluentModal
          isOpen={isOpen}
          onDismiss={closeModal}
          styles={{
            main: {
              minWidth: '400px',
              overflowY: 'unset',
            },
          }}
        >
          <Suspense fallback={<ProgressIndicator />}>
            <LazySalesCreditForm
              modalClose={true}
              onClose={closeModal}
              readOnly={readOnly}
              temporaryDefault={true}
              activeTabId={activeTabId}
              overrideParams={{ uuid: newCreditUuid }}
              formData={{ defaultRecord: initialValues }}
              viaTradeCounter={viaTradeCounter}
              miniForm={openMiniForm}
              miniFormAction={miniFormAction}
            />
          </Suspense>
        </FluentModal>
      </ModalContext.Provider>
    );
  }
);

export default SalesCreditFormModal;
